import React from 'react';
import {connect} from 'react-redux';
import SMCPage from '../../../components/core/pageComponents/SMCPage';
import {useResultsTableDimensions, useBoolean, useToggle} from '../../../utils/hooks';
import SMCTable from '../../../components/core/SMCTable/SMCTable';
import {useRoleResults} from './roleResultsHelper';
import {rolePermissionsSelector} from '../../../store/selectors/user.selectors';
import RoleWizard from '../../Wizards/RoleWizard';
import RoleFilterPane from '../../Filters/RoleFilterPane';
import {helpContextPageUrl} from '../../../conf/Routes';
import SMCTableActions from '../../../components/core/SMCTableActions/SMCTableActions';
import {UserFilterSchema} from '../../../api/DBSchema/User';

function RoleResults({
    rolePermissions
}) {

    const [tableWidth, tableHeight] = useResultsTableDimensions();
    const [isNewObjectWindowOpen, openNewObjectWindow, closeNewObjectWindow] = useBoolean(false);
    const [isFilterPaneOpen, toggleFilterPane] = useToggle(false);
    
    const {
        tableContent,
        isFetching,
        isPageLoaded,
        filterObject,
        setFilterObject,
        freeTextSearch,
        fetchNextPage,
        isLastPage,
        columns,
        sortBasis,
        sortDirection,
        setSort,
        columnsState,
        setColumnsState,
        setDefaultColumnsState,
        rowIdSelector,
        isRowSelectable,
        selectedObjects,
        setSelectedObjects,
        columnsWidths,
        setColumnsWidths,
        newObjectCallback,
        reloadButtonOnClick,
        deleteButtonOnClick
    } = useRoleResults();

    const canDelete = rolePermissions ? rolePermissions.delete : false;
    const canCreate = rolePermissions ? rolePermissions.create : false;

    return (
        <SMCPage loading={!isPageLoaded} helpId={helpContextPageUrl.roleResults}>
            <div className="DrawResultsDiv">
                <SMCTableActions
                    openNewObjectWindow={openNewObjectWindow}
                    reloadButtonOnClick={reloadButtonOnClick}
                    deleteButtonOnClick={deleteButtonOnClick}
                    toggleFilterPane={toggleFilterPane}
                    canCreate={canCreate}
                    canDelete={canDelete}
                    isFetching={isFetching} 
                    tableContent={tableContent}
                    isFilterPaneOpen={isFilterPaneOpen}
                    initialFilter={filterObject}
                    onSearchChange={setFilterObject}
                    searchAttribute={UserFilterSchema.freeTextSearch}
                    showFilter={false} 
                    selectedObjects={selectedObjects}
                /> 
                <SMCTable
                    columns={columns}
                    columnsState={columnsState}
                    setColumnsState={setColumnsState}
                    setDefaultColumnsState={setDefaultColumnsState}
                    selectedObjects={selectedObjects}
                    setSelectedObjects={setSelectedObjects}
                    hasCheckAll={true}
                    defaultColumnsWidths={columnsWidths}
                    onEndResizingColumns={setColumnsWidths}
                    content={tableContent}
                    sortBasis={sortBasis}
                    sortDirection={sortDirection}
                    setSort={setSort}
                    loading={isFetching}
                    onRequestLoadPage={fetchNextPage}
                    isLastPage={isLastPage}
                    width={tableWidth}
                    height={tableHeight}
                    isRowSelectable={isRowSelectable}
                    rowIdSelector={rowIdSelector}
                    isFilterOpen={isFilterPaneOpen}
                    filterElem={
                        <RoleFilterPane
                            initialFilter={filterObject}
                            onFilterChange={setFilterObject}
                            open={isFilterPaneOpen}
                        />
                    }
                    textToHighlight={freeTextSearch}
                    showEditIcon={false}
                />
                {/* Floating windows */}
                <RoleWizard
                    isOpen={isNewObjectWindowOpen}
                    onRequestClose={closeNewObjectWindow}
                    onSuccess={newObjectCallback}
                />
            </div>
        </SMCPage>
    );
}

const mapStateToProps = state => ({
    rolePermissions: rolePermissionsSelector(state)
});

const mapDispatchToProps = null;

export default connect(mapStateToProps, mapDispatchToProps)(RoleResults);